<div [style.--button-background-color]="style?.background_color" [style.--button-color]="style?.color">
  <ng-content></ng-content>
</div>
